import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Injectable({
    providedIn: 'root'
})
export class TranslateInitializerService {
    constructor(
        private translate: TranslateService,
        private languageService: LanguageService
    ) { }

    async initialize() {
        const supportedLanguages = this.languageService.getSupportedLanguages();
        const languageCodes = supportedLanguages.map(lang => lang.code);

        this.translate.addLangs(languageCodes);

        this.translate.setDefaultLang('en');

        const currentLang = this.languageService.getCurrentLanguage();

        try {
            await this.translate.use(currentLang).toPromise();
        } catch (error) {
            console.error('Error loading translations:', error);
            await this.translate.use('en').toPromise();
        }

        this.languageService.currentLanguage$.subscribe(lang => {
            this.translate.use(lang);
        });
    }
}